module.exports = __webpack_public_path__ + "img/ry_3.8287d894.jpg";